import { render, staticRenderFns } from "./StatsMonthYear.vue?vue&type=template&id=4c0ab2b6&scoped=true"
import script from "./StatsMonthYear.vue?vue&type=script&lang=js"
export * from "./StatsMonthYear.vue?vue&type=script&lang=js"
import style0 from "./StatsMonthYear.vue?vue&type=style&index=0&id=4c0ab2b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c0ab2b6",
  null
  
)

export default component.exports